import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><g fill=\"#007CC2\"><path d=\"M12 12.7V17h1v-6h-.7l-1.8 1.8.7.7z\"></path><path d=\"M19 5h-1c0-.6-.4-1-1-1s-1 .4-1 1H8c0-.6-.4-1-1-1s-1 .4-1 1H5c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m1 13c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V9h16zm0-10H4V7c0-.6.4-1 1-1h14c.6 0 1 .4 1 1z\"></path></g><path d=\"M0 0h24v24H0z\"></path></g>", 1)
  ]))]))
}
export default { render: render }